import { v1 as JSBClient } from '@css/otter-js-bridge-client';

export const jsbc = new JSBClient();
